import { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import useRollbackJobChangeProcess from '../api/useRollbackJobChangeProcess';
import { currentSelectjobChangeProcessAtom } from '../atoms/jobChangeProcess';
import { showSuccessToast, showErrorToast } from '../lib/toast';

// サイドバーの「提案まで戻す」は複数画面から使うため共通化する
export default function useRollbackHandler(onSuccess: () => void | Promise<void>) {
  const currentSelectjobChangeProcess = useAtomValue(currentSelectjobChangeProcessAtom);
  const rollbackMutation = useRollbackJobChangeProcess();

  const handleRollback = useCallback(async () => {
    if (!currentSelectjobChangeProcess?.id) return;

    try {
      await rollbackMutation.mutateAsync({
        jobChangeProcessId: currentSelectjobChangeProcess.id,
      });
      showSuccessToast('提案まで戻しました');
      await onSuccess();
    } catch (error) {
      showErrorToast(error instanceof Error ? error.message : '提案まで戻す処理に失敗しました');
    }
  }, [currentSelectjobChangeProcess?.id, rollbackMutation, onSuccess]);

  return { handleRollback, isRollbackPending: rollbackMutation.isPending };
}
